import { render, staticRenderFns } from "./VAutocompleteText.vue?vue&type=template&id=4bbc9bc3"
import script from "./VAutocompleteText.vue?vue&type=script&lang=js"
export * from "./VAutocompleteText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports